module.exports = __webpack_public_path__ + "static/media/profpict-old.b36ea21b.jpg";